// extracted by mini-css-extract-plugin
export var lightMode = "_18-0";